import { ResultType } from 'common/common.constants';
import { validateOAuthResult } from 'components/form/api/admin.api';
import { ValidateOAuthResultOutput } from 'components/form/interfaces/member.interface';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function OauthLoginForm({ resultToken }: { resultToken: string }) {
  const navigate = useNavigate(); // 히스토리 구하기

  const [sendAddressSeq, setSendAddressSeq] = useState<String>('');
  const [returnAddressSeq, setReturnAddressSeq] = useState<String>('');

  useEffect(() => {
    if (!resultToken) {
      Swal.fire({
        title: '실패',
        html: `정상적인 접근 경로가 아닙니다.`,
        icon: 'error',
      });

      // navigate(`/st11/member/create-account`);
    }
    if (resultToken) {
      validateResult({ state: resultToken }); // body: { state: string }
    }

    const sessionAddressReq = sessionStorage.getItem('addressSeq');
    if (sessionAddressReq) {
      const addressSeq = JSON.parse(sessionAddressReq);

      setSendAddressSeq(addressSeq.sendAddressSeq);
      setReturnAddressSeq(addressSeq.returnAddressSeq);
    }
  }, [resultToken]);

  const { mutate: validateResult } = useMutation(validateOAuthResult, {
    onSuccess: async (data: ValidateOAuthResultOutput) => {
      const { success, loginToken, message, resultType, email } = data;
      const typeDescription = resultType === ResultType.CREATE_ACCOUNT ? '간편 회원 가입' : '로그인';
      if (success) {
        let html = '';
        // 회원 가입일 경우
        if (resultType === ResultType.CREATE_ACCOUNT) {
          html = `<div class="textArea">
          <div class="primaryText">
          ${typeDescription}이 완료 되었습니다. <p>
          </div>
          <div class="additionalArea">
            <b>회원님의 <b style="color:#0066cc;">${email}</b> 로<br>
            <b>임시 비밀번호</b>가 발급되었습니다.
            로그인 후 반드시 <b>비밀번호를 변경</b>해 주세요.<br>
          </div>
        </div>`;
        } else {
          html = `<div class="textArea">
          <div class="primaryText">
          ${typeDescription}이 완료 되었습니다. <p>
          </div>
          <div class="additionalArea">
            입력하신 이메일 <b style="color:#0066cc;">${email}</b> 는<br>
            이미 가입된 회원입니다.
            <b>11번가 계정 인증</b>을 통해<br>
            자동으로 로그인 처리되었습니다.
          </div>
        </div>`;
        }
        await Swal.fire({
          title: typeDescription,
          html: html,
          icon: 'success',
          confirmButtonText: '확인',
        });

        window.location.href = `${process.env.REACT_APP_GMP_API_ENDPOINT}/login.html?sendAddressSeq=${data.sendAddressSeq}?returnAddressSeq=${data.returnAddressSeq}?utm_source=letter&utm_medium=email&utm_campaign=wakeup&utm_content=complete_mail_1&p=/startWakeUp&wakeup_user_token=${loginToken}`;
      } else {
        await Swal.fire({
          title: '실패',
          html: message,
          icon: 'error',
          confirmButtonText: '확인',
        });

        navigate(`/st11/member/create-account`);
      }
    },
    onError: async (error: any) => {
      const errorMessage = error?.response?.data?.message || error?.response?.message || error?.message;
      await Swal.fire({
        title: '에러',
        html: errorMessage,
        icon: 'error',
      });

      navigate(`/st11/member/create-account`);
    },
  });
  return <></>;
}
